import React, { useState,useContext,useEffect } from "react";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { makeStyles } from "@material-ui/core/styles";
import { ColumnStyle } from "../theme/ComponentTheme";
import { ShiftProps } from "../interfacesProps/ShiftProps";
import { ShiftService } from "../api/ShiftService";
import { ShiftRelatedConstants, ShiftRelatedStylingConstants } from "../util/ShiftConstants";
import { Colors, FontSize, FontWeight, Spacing } from "../theme/Theme";
import moment from "moment-timezone";
import { capitalize, ButtonBase } from "@material-ui/core";
import {
  defaultKmAllowanceIcon,
  defaultAccomodationAllowanceIcon,
} from "../util/Icons";
import { RBShiftLayoutButton } from "./RBShiftLayoutButton";
import { formatWorkerType } from "../util/FormattingService";
import { IndustryModeEnum, roleNameEnum } from "../util/Common";
import { UIRelatedConstants } from "../theme/Theme";
import { RBContext } from './RBContext';
import { AuthService } from "../api/AuthService";
import { ObjectLiteral } from "../interfacesProps/ObjectLiteralProps";
import { defaultAllowOffersIcon } from '../components/RBShiftRelatedIcons';
import { findUserShiftRequest } from "../util/ShiftToRequest";
import ShiftRatedRow from "./ShiftRatedRow";
import { ShiftPaymentField } from "./ShiftPayment/ShiftPaymentField";
import { getShiftRatingValue, isShiftRatingWindowOpen } from "../util/shiftRating";
import { getPaymentInfoAvailability } from "../util/PaymentInfoAvailability";
const useStyles = makeStyles({
  Card: {
    "&:hover": {
      backgroundColor: "#E5E5E5",
      cursor: "pointer",
    },
  },
  CardContent: {
    paddingTop: 8,
    "&:last-child": {
      paddingBottom: 8,
    },
  },
});
interface RBShiftLayoutCardProps {
  shift: ShiftProps;
  rolename: string;
  onClick: (shiftId: string) => void;
  account:ObjectLiteral;
  userId?:string;
  shiftState?:number;
}

const renderStateHeaderForWorker = (
  shift: ShiftProps,
  primaryColor: string,
  secondaryColor: string,
  rolename: string,
  account: any,
  industryMode: string,
  userId?: string
) => {
  const isAssigned = shift?.flags.isAssigned;
  // find the exact shift->request element for this user and derive isRequested
  const userRequest = findUserShiftRequest(shift, userId);
  console.log("userRequest",userRequest)
  const isRequested =
    !!(
      userRequest &&
      (userRequest.isWageRequested||
        userRequest.isStartTimeRequested||
        userRequest.isEndTimeRequested)
    );
    console.log("isRequested",isRequested)

  console.log("shift in renderStateHeaderForWorker",shift)
  const state = ShiftService.getStatusForShiftAsWorker(shift, rolename, industryMode);
  let shiftStateStatus = state;
    console.log("shiftStateStatus",shiftStateStatus)
    if ((!shift.networkPaid && shift?.workerAutoAcknowledged && shift?.workerAutoAcknowledged === true)) {
      if(shift.flags.isAssigned && shift.flags.isCompleted ){
        
        if(!shift.flags.isCompletionAcknowledged){
          if (shift.flags.isDisputed) {
            shiftStateStatus =  ShiftRelatedConstants.ShiftStateText.InDispute;
          }
          shiftStateStatus =ShiftRelatedConstants.ShiftStateText.AwaitingHoursConfirmation;
        }
        if(shift.flags.isCompletionAcknowledged){
          shiftStateStatus = ShiftRelatedConstants.ShiftStateText.ShiftCompleted
        }
      }
    }
    
  let stateColor =
    ShiftRelatedStylingConstants.Colors[
      ShiftService.getStatusForShiftAsWorker(shift, rolename, industryMode)
    ];

  if (
    shiftStateStatus === ShiftRelatedConstants.ShiftStateText.RateShift &&
    shift?.flags?.isCompleted &&
    !shift?.flags?.isCompletionAcknowledged
  ) {
    shiftStateStatus = ShiftRelatedConstants.ShiftStateText.AwaitingHoursConfirmation;
  }

  if(stateColor === '#2B3270')
  {
    stateColor = primaryColor;
  }
  else if(stateColor === '#6EC9CD'){
    stateColor = secondaryColor;
  }

  const shiftNetworkPaid = shift.networkPaid ? shift.networkPaid : shift.pharmacy.networkPaid;
  const isPaid = !!shift?.paymentData;
  const isNetworkPaid = !!shiftNetworkPaid;
  const showPaidBadge = !isNetworkPaid && isPaid;

  return (
    <>
    <div style={{ ...ColumnStyle, paddingBottom: 0 }}>
      <div
        style={{
          fontSize: FontSize.large,
          fontWeight: "bold",
          color: stateColor,
        }}
      >
        {shiftStateStatus}
        {!isAssigned && isRequested && (
          <span style={{ paddingLeft: Spacing.small }}>(Applied with Request)</span>
        )}
      </div>

      {showPaidBadge ? (
        <div
          style={{
            color: "#1B5E20",
            width:90,
            boxSizing: "border-box",
            paddingLeft: 13,
            paddingRight: 13,
            paddingTop: 2,
            paddingBottom: 2,
            textAlign: "center",
            backgroundColor: "#C8E6C9",
          }}
        >
          Paid
        </div>
      ) : null}
      </div>
    </>
  );
};
const renderJobStateHeaderForWorker = (shift: ShiftProps,primaryColor:string,secondaryColor:string) => {
  
  const state = ShiftService.getStatusForJobAsWorker(shift);
  let stateColor =
    ShiftRelatedStylingConstants.Colors[
      ShiftService.getStatusForJobAsWorker(shift)
    ];
  if(stateColor === '#2B3270')
  {
    stateColor = primaryColor;
  }
  else if(stateColor === '#6EC9CD'){
    stateColor = secondaryColor;
  }
  return (
    <div
      style={{
        fontSize: FontSize.large,
        fontWeight: "bold",
        color: stateColor,
      }}
    >
      {state}
    </div>
  );
};
const renderStateHeaderForPharmacy = (
  shift: ShiftProps,
  primaryColor: string,
  secondaryColor: string,
  rolename: string,
  industryMode: string
) => {
  const state = ShiftService.getStatusForShiftAsPharmacy(shift, rolename, industryMode);
  let stateText = state;

  if(!shift.networkPaid && 
    shift?.locationAutoAcknowledged &&
     shift?.locationAutoAcknowledged === true){
    if(shift.flags.isCompletionAcknowledged){
      stateText = ShiftRelatedConstants.ShiftStateText.ShiftCompleted
    }

  }

  let stateColor =
    ShiftRelatedStylingConstants.Colors[
      ShiftService.getStatusForShiftAsPharmacy(shift, rolename, industryMode)
    ];

    if(stateColor === '#2B3270')
    {
      stateColor = primaryColor;
    }
    else if(stateColor === '#6EC9CD'){
      stateColor = secondaryColor;
    }
    const shiftNetworkPaid = shift.networkPaid? shift.networkPaid : shift.pharmacy.networkPaid;
    const isPaid = !!shift?.paymentData;
    const isNetworkPaid = !!shiftNetworkPaid;

    const showPaidBadge = !isNetworkPaid && isPaid;

  
  return (
    <>
    <div style={{ ...ColumnStyle, paddingBottom: 0 }}>
    <div
      style={{
        fontSize: FontSize.large,
        fontWeight: "bold",
        color: stateColor,
      }}
    >
      {stateText}
    </div>

      {showPaidBadge ? (
        <div
          style={{
            color: "#1B5E20",
            paddingLeft: 13,
            paddingRight: 13,
            paddingTop: 2,
            paddingBottom: 2,
            textAlign: "center",
            backgroundColor: "#C8E6C9",
          }}
        >
          Paid
        </div>
      ) : null}
  </div>
   </>
)};

const renderAllowance = (shift: ShiftProps,primaryColor:string) => {
  const kmAllowanceAvailable = shift.kmAllowance > 0;
  const accomodationAllowanceAvailable = shift.accomodationAllowance > 0;
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-end",
        alignItems: "center",
        // marginTop: spacing.small,
      }}
    >
      {kmAllowanceAvailable && (
        <div style={{ marginRight: 4 }}>{defaultKmAllowanceIcon(primaryColor)}</div>
      )}
      {accomodationAllowanceAvailable && (
        <div>{defaultAccomodationAllowanceIcon(primaryColor)}</div>
      )}
    </div>
  );
};
const renderContentForWorker = (
  shift: ShiftProps,
  setCardActionAreaClickable: (actionAreaClickable: boolean) => void,
  rolename: string,
  primaryColor:string,
  secondaryColor: string,
  account:any,
  industryMode: string,
  userId?:string,
  shiftState?:number,
) => {
  console.log('shifts in rbshiftlayoutcard',shift)
   const userRequest = findUserShiftRequest(shift, userId);
  const isAssigned = shift.flags.isAssigned;
   // find the exact shift->request element for this user and derive isRequested
  // const userRequest = findUserShiftRequest(shift, userId);
  console.log("userRequest",userRequest)
  const isRequested =
    !!(
      userRequest &&
      (userRequest.isWageRequested||
        userRequest.isStartTimeRequested||
        userRequest.isEndTimeRequested)
    );
  
  // use requested start/end if present, otherwise fall back to official times
  const startTimeRaw =
    userRequest && userRequest.requestedStartTime
      ? userRequest.requestedStartTime
      : shift.officialStartTime;
  const endTimeRaw =
    userRequest && userRequest.requestedEndTime
      ? userRequest.requestedEndTime
      : shift.officialEndTime;
  // const startTime = moment(shift.officialStartTime).tz(shift.shiftTimeZone);
  // const endTime = moment(shift.officialEndTime).tz(shift.shiftTimeZone);
  // const hoursDisplay = ShiftService.getShiftOfficialLengthDisplay(shift);
  // const wage = shift.actualCommission ?  shift.wage:ShiftService.getWage(shift,account);
  const isPaid = !!shift?.paymentData;

  const stateGlobalColor = ShiftRelatedStylingConstants.Colors[
    ShiftService.getStatusForShiftAsWorker(shift, rolename ,industryMode)
  ];
  let paidLabelColor = stateGlobalColor;
  if (paidLabelColor === "#2B3270") {
    paidLabelColor = primaryColor;
  } else if (paidLabelColor === "#6EC9CD") {
    paidLabelColor = secondaryColor;
  } else if (!paidLabelColor) {
    paidLabelColor = secondaryColor;
  }

  const startTime = moment(startTimeRaw).tz(shift.shiftTimeZone);
  const endTime = moment(endTimeRaw).tz(shift.shiftTimeZone);

  // hours display: use requested times if both present, otherwise use service
  const formatDuration = (dur: moment.Duration) => {
    const totalMins = Math.floor(dur.asMinutes());
    const hrs = Math.floor(totalMins / 60);
    const mins = totalMins % 60;
    if (hrs > 0 && mins > 0) {
      return `${hrs} ${hrs === 1 ? "hr" : "hrs"} ${mins} ${mins === 1 ? "min" : "mins"}`;
    }
    if (hrs > 0) return `${hrs} ${hrs === 1 ? "hr" : "hrs"}`;
    return `${mins} ${mins === 1 ? "min" : "mins"}`;
  };

  let hoursDisplay;
  if (userRequest && userRequest.requestedStartTime && userRequest.requestedEndTime) {
    const diffMs = moment(endTime).diff(moment(startTime));
    const dur = moment.duration(diffMs);
    hoursDisplay = formatDuration(dur);
  } else {
    hoursDisplay = ShiftService.getShiftOfficialLengthDisplay(shift);
  }

  // wage: prefer requestedWage if provided
  let wage = shift.actualCommission !== undefined && shift.actualCommission !== null ? shift.wage : ShiftService.getWage(shift, account);
  if (userRequest && userRequest.requestedWage != null) {
    wage = userRequest.requestedWage;
  }

  //example: Wed, Nov 6th 2019
  const dateDisplay = startTime.format("ddd, MMM Do YYYY");
  const shiftCity = shift.shiftCity ?? "N/A";
  const shiftNumber = shift.shiftNumber || 'N/A';
  // const numericShiftState = Number(shiftState);

const numericShiftState = Number(shiftState);

  // prefer per-request state fields (common field names)
  const isAppliedFromRequest =
    !!userRequest &&
    (Number(userRequest.state) === 1 ||
      Number(userRequest.requestState) === 1 ||
      (typeof userRequest.status === "string" &&
        (userRequest.status.toLowerCase() === "pending" || userRequest.status.toLowerCase() === "applied")));

  // Only show content color-coding when the page/tab is the "Applied" tab.
  const isAppliedTab = numericShiftState === 1;

  // If we're on the Applied tab and there is a userRequest, show:
  // - orange when a specific value was requested
  // - green when the request exists but that particular field was NOT changed
  // Otherwise leave color as default (undefined).
  let timeColor: string | undefined = undefined;
  let wageColor: string | undefined = undefined;

  if (isAppliedTab && userRequest && isRequested) {
    const timeRequested = !!(userRequest.isStartTimeRequested || userRequest.isEndTimeRequested);
    const wageRequested = !!userRequest.isWageRequested;

    timeColor = timeRequested ? "#F57C00" : "rgb(52, 175, 71)";
    wageColor = wageRequested ? "#F57C00" : "rgb(52, 175, 71)";
  }
  // debug: if still wrong, uncomment to inspect userRequest shape
  console.log('userRequest fields', userRequest, 'isAppliedFromRequest', isAppliedFromRequest, 'tabShiftState', numericShiftState);

  const ratingValue = getShiftRatingValue(shift, industryMode, rolename);
  const hasRatingValue = ratingValue != null && Number.isFinite(ratingValue);
  const ratingWindowOpen = isShiftRatingWindowOpen(shift);
  const isRatingRelevant =
    !!shift?.flags &&
    !shift.flags.isCancelled &&
    !shift.flags.isDisputed &&
    !!(shift.flags.isCompletionAcknowledged || shift.flags.isCompleted);
  const shouldShowNotRated = isRatingRelevant && !hasRatingValue && !ratingWindowOpen;

  return (
    <div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          flex: 1,
        }}
      >
        <div style={{ flex: 3 }}>
          <div style={{ fontWeight: "bold" }}>
            {capitalize(startTime.fromNow())}
          </div>
          <div>{shiftNumber}</div>
          <div style={{ color: timeColor}}>{dateDisplay}</div>
          <div style={{ color: timeColor }}>
            {startTime.format("hh:mm a")} - {endTime.format("hh:mm a")}
          </div>
          <div>
            <label style={{ fontWeight: "bold" }}>
              In <label style={{ fontWeight: "normal" }}> {shiftCity}</label>
            </label>
          </div>

        </div>
        <div
          style={{
            flex: 2,
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-end",
            justifyContent: "space-between",
          }}
        >
          <div style={{ fontWeight: "bold", textAlign: "right", color: wageColor }}>
            ${(wage / 100).toFixed(2)}/hr
          </div>

          {renderAllowance(shift,primaryColor)}
          <div style={{ fontWeight: "bold", textAlign: "right" }}>
            {hoursDisplay}
          </div>

          {hasRatingValue && (
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-end",
                marginTop: 6,
              }}
            >
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <ShiftRatedRow
                  shift={shift}
                  industryMode={industryMode as any}
                  roleName={rolename}
                />
              </div>
              {/* <div style={{ fontWeight: "bold", marginTop: 2 }}>
                {ratingValue?.toFixed(1)}
              </div> */}
            </div>
          )}

          {/* {shouldShowNotRated && (
            <div
              style={{
                width: "100%",
                marginTop: 6,
                fontWeight: "bold",
                color: Colors.darkGrey,
                textAlign: "right",
              }}
            >
              Not Rated
                 </div>
          {/* {isPaid && (
            <div
              style={{
                fontWeight: 600,
                color: paidLabelColor,
                textAlign: "right",
              }}
            >
              Paid
            </div>
          )} */}
        </div>
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "row",
          paddingTop: 10,
          justifyContent: "space-between",
          minHeight: 45,
          flexWrap: "wrap",
          gap: 8,
        }}
      >
        <div
          style={{
            justifyContent: "center",
            display: "flex",
            alignItems: "center",
            minWidth: 0,
            flexShrink: 1,
          }}
        >
          {/* US6559 Phase 2 — how this shift gets paid, on the worker's own shift-list card.
              Field only: the "if you are selected for this shift" note does not apply to a
              shift the worker already holds. Wraps to its own line rather than colliding with
              the action button when the card is narrow. */}
          <ShiftPaymentField shift={shift} inline />
        </div>

        <div
          style={{ alignItems: "flex-end", flexShrink: 0 }}
          onMouseEnter={() => {
            setCardActionAreaClickable(false);
          }}
          onMouseLeave={() => {
            setCardActionAreaClickable(true);
          }}
        >
          <RBShiftLayoutButton shift={shift} rolename={rolename} />
        </div>
      </div>
    </div>
  );
};

const renderJobContentForWorker = (
  shift: ShiftProps,
  setCardActionAreaClickable: (actionAreaClickable: boolean) => void,
  rolename: string,
  primaryColor:string,
  account:any
) => {
  
  const startDate = shift.estStartDate;
  const endDate = shift.expireAt;
  // const hoursDisplay = ShiftService.getShiftLengthDisplayForOriginal(shift);
  const wage = shift.estHourlyRate;
  const jobCategory = shift.jobCategory.name;
  const pharmacistType = shift.pharmacistType;


  //example: Wed, Nov 6th 2019
  const dateDisplay = startDate;
  const jobCity = shift.jobCity ?? "N/A";
  return (
    <div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          flex: 1,
        }}
      >
        <div style={{ flex: 3 }}>
          <div>
            Est. Start Date
          </div>
          <div>{dateDisplay}</div>
          <div>
            In <label style={{ fontWeight: "normal" }}> {jobCity}</label>
          </div>
        </div>
        <div
          style={{
            flex: 2,
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-end",
            justifyContent: "space-between",
          }}
        >
          <div style={{textAlign: "right" }}>
            {jobCategory}
          </div>
          <div style={{textAlign: "right" }}>
            ${(wage / 100).toFixed(2)}/hr
          </div>
          <div style={{textAlign: "right" }}>
            {capitalize(pharmacistType)}
          </div>

          {renderAllowance(shift,primaryColor)}
          {/* <div style={{ fontWeight: "bold", textAlign: "right" }}>
            {hoursDisplay}
          </div> */}
        </div>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          paddingTop: 10,
          justifyContent: "space-between",
          minHeight: 45,
        }}
      >
        {/* <div style={{ justifyContent: "center" }}>
          <div>
            <label style={{ fontWeight: "bold" }}>
            </label>
          </div>
        </div> */}

        <div
          style={{ alignItems: "flex-end" }}
          onMouseEnter={() => {
            setCardActionAreaClickable(false);
          }}
          onMouseLeave={() => {
            setCardActionAreaClickable(true);
          }}
        >
          <RBShiftLayoutButton shift={shift} rolename={rolename} />
        </div>
      </div>
    </div>
  );
};

const renderContentForPharmacy = (
  shift: ShiftProps,
  setCardActionAreaClickable: (actionAreaClickable: boolean) => void,
  rolename: string,
  account:any,
  industryMode:string,
  primaryColor: string,
  secondaryColor:string
) => {
  const startTime = moment(shift.officialStartTime).tz(shift.shiftTimeZone);
  const endTime = moment(shift.officialEndTime).tz(shift.shiftTimeZone);
  const hoursDisplay = ShiftService.getShiftOfficialLengthDisplay(shift);
  //const wage = ShiftService.getWage(shift,account);
  const wage = (industryMode === IndustryModeEnum.Dentistry || industryMode === IndustryModeEnum.Labour) ?(ShiftService.getWage(shift,account)).toFixed(2) : (shift.actualCommission !== undefined && shift.actualCommission !== null ? shift.wage  : (ShiftService.getWage(shift,account)).toFixed(2));


  const workerType = shift.pharmacistType;
  //example: Wed, Nov 6th 2019
  const dateDisplay = startTime.format("ddd, MMM Do YYYY");
  const pharmacyName = shift.pharmacy.name ?? "N/A";
  const shiftNumber = shift.shiftNumber || 'N/A';


  const { isAssigned } = shift.flags;
    const { allowOffers } = shift;
  const isPaid = !!shift?.paymentData;

  const stateGlobalColor = ShiftRelatedStylingConstants.Colors[
    ShiftService.getStatusForShiftAsPharmacy(shift, rolename ,industryMode)
  ];
  let paidLabelColor = stateGlobalColor;
  if (paidLabelColor === "#2B3270") {
    paidLabelColor = primaryColor;
  } else if (paidLabelColor === "#6EC9CD") {
    paidLabelColor = secondaryColor;
  } else if (!paidLabelColor) {
    paidLabelColor = secondaryColor;
  }

  const ratingValue = getShiftRatingValue(shift, industryMode, rolename);
  const hasRatingValue = ratingValue != null && Number.isFinite(ratingValue);
  const ratingWindowOpen = isShiftRatingWindowOpen(shift);
  const isRatingRelevant =
    !!shift?.flags &&
    !shift.flags.isCancelled &&
    !shift.flags.isDisputed &&
    !!shift.flags.isCompletionAcknowledged;
  const shouldShowNotRated = isRatingRelevant && !hasRatingValue && !ratingWindowOpen;

  return (
    <div>
      <div style={{ display: "flex", flexDirection: "row", flex: 1 }}>
        <div style={{ flex: 3 }}>
          <div style={{ fontWeight: "bold" }}>
            {capitalize(startTime.fromNow())}
          </div>
          <div>{shiftNumber}</div>
          <div>{dateDisplay}</div>
          <div>
            {startTime.format("hh:mm a")} - {endTime.format("hh:mm a")}
          </div>
           <div style={{ justifyContent: "center" }}>
          <div>
            <label style={{ fontWeight: "bold" }}>
              At <label style={{ fontWeight: "normal" }}> {pharmacyName}</label>
            </label>
          </div>
        </div>
        </div>
        <div
          style={{
            flex: 2,
            alignItems: "flex-end",
            justifyContent: "space-between",
          }}
        >
          {/* <div style={{ fontWeight: "bold", textAlign: "right",display:"flex",flexDirection:"row",alignItems: 'flex-end'}}>
            ${(wage / 100).toFixed(2)}/hr
            { (allowOffers && !isAssigned) && 
              <div>
                {defaultAllowOffersIcon(secondaryColor)}
              </div>
            }
          </div> */}

          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              alignItems: "center",
              // marginTop: spacing.small,
            }}
          >
            <div style={{ marginRight: 4,fontWeight: "bold" }}>${(wage / 100).toFixed(2)}/hr</div>
            { (allowOffers && !isAssigned) && 
              <div style={{paddingTop:2}}>
                 {defaultAllowOffersIcon(secondaryColor)}
              </div>
            }
          </div>


          <div style={{ fontWeight: "bold", textAlign: "right" }}>
            {formatWorkerType(workerType)}
          </div>
          <div style={{ fontWeight: "bold", textAlign: "right" }}>
            {hoursDisplay}
          </div>
          {hasRatingValue && (
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-end",
                // marginTop: 6,
              }}
            >
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <ShiftRatedRow
                  shift={shift}
                  industryMode={industryMode as any}
                  roleName={rolename}
                />
              </div>
              {/* <div style={{ fontWeight: "bold", marginTop: 2 }}>
                {ratingValue?.toFixed(1)}
              </div> */}
            </div>
      )}

          {/* {shouldShowNotRated && (
            <div
              style={{
                width: "100%",
                marginTop: 6,
                fontWeight: "bold",
                color: Colors.darkGrey,
                textAlign: "right",
              }}
            >
              Not Rated
            </div>
      )} */}
          {/* {isPaid && (
            <div
              style={{
                fontWeight: "bold",
                color: paidLabelColor,
                textAlign: "right",
              }}
            >
              Paid
            </div>
          )} */}
        </div>
      </div>

      

      <div
        style={{
          display: "flex",
          flexDirection: "row",
          paddingTop: 5,
          justifyContent: "space-between",
          minHeight: 45,
        }}
      >
        <div style={{ justifyContent: "center" }}>
          <div>
            {/* <label style={{ fontWeight: "bold" }}>
              At <label style={{ fontWeight: "normal" }}> {pharmacyName}</label>
            </label> */}
          </div>
        </div>

        <div
          style={{ alignItems: "flex-end" }}
          onMouseEnter={() => {
            setCardActionAreaClickable(false);
          }}
          onMouseLeave={() => {
            setCardActionAreaClickable(true);
          }}
        >
          <RBShiftLayoutButton shift={shift} rolename={rolename} />
        </div>
      </div>
    </div>
  );
};
const RenderShiftLayoutForWorker = (
  shift: ShiftProps,
  onClick: (shiftId: string) => void,
  rolename: string,
  account:any,
  userId?:string,
  shiftState?:number,
) => {
  const classes = useStyles();
  const { industryMode,primaryColor,secondaryColor } = useContext(RBContext);
  const [CardActionAreaClickable, SetCardActionAreaClickable] = useState(true);
  const [stateColor,setStateColor] = useState<any>( ShiftRelatedStylingConstants.Colors[
    ShiftService.getStatusForShiftAsWorker(shift,rolename,industryMode)
  ])

    useEffect(() => {
      const stateGlobalColor = ShiftRelatedStylingConstants.Colors[
        ShiftService.getStatusForShiftAsWorker(shift,rolename,industryMode)
      ];
      if(stateGlobalColor === '#2B3270')
      {
        setStateColor(primaryColor)
      }
      else if(stateGlobalColor === '#6EC9CD'){
        setStateColor(secondaryColor)
      }
    }, []);
  return (
    <Card
      variant="outlined"
      className={classes.Card}
      style={{
        borderRadius: UIRelatedConstants.CardBorderRadius,
        borderWidth: 3,
        borderColor: stateColor,
      }}
    >
      <div
        onClick={() => {
          if (CardActionAreaClickable) {
            onClick(shift.id);
          } else {
            console.log("CardActionAreaClickable is false");
          }
        }}
      >
        <CardContent className={classes.CardContent}>
          {renderStateHeaderForWorker(
            shift,
            primaryColor,
            secondaryColor,
            rolename,
            account,
            industryMode,
            userId,
          )}
          {renderContentForWorker(
            shift,
            SetCardActionAreaClickable,
            rolename,
            primaryColor,
            secondaryColor,
            account,
            industryMode,
            userId,
            shiftState,
          )}
        </CardContent>
      </div>
    </Card>
  );
};
const RenderJobLayoutForWorker = (
  shift: ShiftProps,
  onClick: (shiftId: string) => void,
  rolename: string,
  account:any
) => {
  const classes = useStyles();
  const [CardActionAreaClickable, SetCardActionAreaClickable] = useState(true);
  const state = ShiftService.getStatusForJobAsWorker(shift);
  const [stateColor,setStateColor] = useState<any>( ShiftRelatedStylingConstants.Colors[
    ShiftService.getStatusForJobAsWorker(shift)
  ])
  const { industryMode,primaryColor,secondaryColor } = useContext(RBContext);

    useEffect(() => {
      const stateGlobalColor = ShiftRelatedStylingConstants.Colors[
        ShiftService.getStatusForJobAsWorker(shift)
      ];
      if(stateGlobalColor === '#2B3270')
      {
        setStateColor(primaryColor)
      }
      else if(stateGlobalColor === '#6EC9CD'){
        setStateColor(secondaryColor)
      }
    }, []);
  return (
    <Card
      variant="outlined"
      className={classes.Card}
      style={{
        borderRadius: UIRelatedConstants.CardBorderRadius,
        borderWidth: 3,
        borderColor: stateColor,
      }}
    >
      <div
        onClick={() => {
          if (CardActionAreaClickable) {
            onClick(shift.id);
          } else {
            console.log("CardActionAreaClickable is false");
          }
        }}
      >
        <CardContent className={classes.CardContent}>
          {renderJobStateHeaderForWorker(shift,primaryColor,secondaryColor)}
          {renderJobContentForWorker(shift, SetCardActionAreaClickable, rolename,primaryColor,account)}
        </CardContent>
      </div>
    </Card>
  );
};
const RenderShiftLayoutForPharmacy = (
  shift: ShiftProps,
  onClick: (shiftId: string) => void,
  rolename: string,
  account:any
) => {
  const classes = useStyles();
  const { industryMode,primaryColor,secondaryColor } = useContext(RBContext);
  const [CardActionAreaClickable, SetCardActionAreaClickable] = useState(true);

  const [stateColor,setStateColor] = useState<any>( ShiftRelatedStylingConstants.Colors[
    ShiftService.getStatusForShiftAsPharmacy(shift,rolename,industryMode)
  ])

  useEffect(() => {
    const stateGlobalColor = ShiftRelatedStylingConstants.Colors[
      ShiftService.getStatusForShiftAsPharmacy(shift,rolename,industryMode)
    ]
    if(stateGlobalColor === '#2B3270')
    {
      setStateColor(primaryColor)
    }
    else if(stateGlobalColor === '#6EC9CD'){
      setStateColor(secondaryColor)
    }
    console.log('stateColor',stateColor)
  }, []);
  
  return (
    <Card
      variant="outlined"
      className={classes.Card}
      style={{
        borderRadius: UIRelatedConstants.CardBorderRadius,
        borderWidth: 3,
        borderColor: stateColor,
      }}
    >
      <div
        onClick={() => {
          if (CardActionAreaClickable) {
            onClick(shift.id);
          } else {
            console.log("CardActionAreaClickable is false");
          }
        }}
      >
        <CardContent className={classes.CardContent}>
          {renderStateHeaderForPharmacy(shift,primaryColor,secondaryColor,rolename,industryMode)}
          {renderContentForPharmacy(
            shift,
            SetCardActionAreaClickable,
            rolename,
            account,
            industryMode,
            primaryColor,
            secondaryColor
          )}
        </CardContent>
      </div>
    </Card>
  );
};

export const RBShiftLayoutCard: React.FC<RBShiftLayoutCardProps> = ({
  ...props
}) => {
  const { shift, onClick, rolename ,account,userId,shiftState} = props;
  if (rolename === roleNameEnum.pharmacist) {
    if (shift.jobNumber){
      return (
        <div
          style={{
            width: "100%",
            paddingLeft: Spacing.large,
            paddingRight: Spacing.large,
            paddingBottom: Spacing.medium,
          }}
        >
          {RenderJobLayoutForWorker(shift, onClick, rolename,account)}
        </div>
      );
    } else {
      return (
        <div
          style={{
            width: "100%",
            paddingLeft: Spacing.large,
            paddingRight: Spacing.large,
            paddingBottom: Spacing.medium,
          }}
        >
          {RenderShiftLayoutForWorker(shift, onClick, rolename,account,userId,shiftState)}
        </div>
      );
    }
  }
  if (rolename === roleNameEnum.owner) {
    return (
      <div
        style={{
          paddingLeft: Spacing.large,
          paddingRight: Spacing.large,
          paddingBottom: Spacing.medium,
        }}
      >
        {RenderShiftLayoutForPharmacy(shift, onClick, rolename,account)}
      </div>
    );
  }
  return <></>;
};
